// import SearchIcon from '@mui/icons-material/Search';
import {
  CircularProgress,
  FormHelperText,
  // InputAdornment,
  ListSubheader,
  MenuItem,
  Select,
  TextField,
} from '@mui/material';
import debounce from 'lodash.debounce';
import moment from 'moment';
import React, { ReactElement, useEffect, useMemo, useState } from 'react';

type InputProps = {
  placeHolder?: string;
  className?: string;
  onChange?: (src: any) => void;
  onFocus?: any;
  onOpen?: () => void;
  extraStyle?: any;
  extraSx?: any;
  menuItemSx?: any;
  value?: string;
  error?: any;
  options?: any;
  labelKey?: string;
  label1Key?: string;
  valueKey?: string;
  id?: string;
  type?: string;
  name?: string;
  ref?: any;
  disabled?: boolean;
  UploadResume?: boolean;
  selectedValue?: string;
  searchable?: boolean;
  valueHighLigt?: string;
  menuStyle?: any;
  IconComponent?: any;
  loading?: boolean;
};

const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: 250,
      width: 250,
    },
  },
};

const CustomSelect = (props: InputProps): ReactElement => {
  const {
    placeHolder,
    className,
    onChange,
    onFocus,
    onOpen,
    extraStyle,
    value,
    error,
    options,
    labelKey,
    label1Key,
    valueKey,
    id,
    name,
    ref,
    type,
    disabled,
    selectedValue,
    searchable,
    valueHighLigt,
    menuStyle,
    extraSx,
    menuItemSx,
    UploadResume,
    IconComponent,
    loading,
  } = props;
  const [showPlaceHolder, setShowPlaceHolder] = useState<boolean>(false);
  const [optionList, setOptionList] = useState<any>([]);
  const [optionListAll, setOptionListAll] = useState<any>([]);
  const [inputValue, setInputValue] = useState<string>('');

  useEffect(() => {
    if (UploadResume) {
      setOptionList(
        options ? options.filter((option: any) => Boolean(option.value)) : [],
      );
      setOptionListAll(
        options ? options.filter((option: any) => Boolean(option.value)) : [],
      );
    } else {
      setOptionList(options);
      setOptionListAll(options);
    }
  }, [options, UploadResume]);

  const onChangeText = React.useCallback(
    (e: string) => {
      const trimmedText = e;
      if (trimmedText) {
        setOptionList([
          ...optionListAll.filter(
            (option) =>
              option[labelKey]
                .toLowerCase()
                .indexOf(trimmedText.toLowerCase()) !== -1,
          ),
        ]);
      } else {
        setOptionList(optionListAll);
      }
    },
    [labelKey, optionListAll],
  );

  // const onChangeText = React.useCallback(
  //   (e: any) => {
  //     if (e?.target?.value) {
  //       setOptionList([
  //         ...optionListAll.filter(
  //           (option) =>
  //             option[labelKey]
  //               .toLowerCase()
  //               .indexOf(e?.target?.value.toLowerCase()) !== -1,
  //         ),
  //       ]);
  //     } else {
  //       setOptionList(optionListAll);
  //     }
  //   },
  //   [labelKey, optionListAll],
  // );

  // const debouncedResults = useMemo(
  //   (e: string) => {
  //     return debouce(() => onChangeText(e), 1000);
  //   },
  //   [onChangeText],
  // );

  const debouncedResults = useMemo(
    () => debounce((e: string) => onChangeText(e), 1000),
    [onChangeText],
  );

  return (
    <>
      <Select
        MenuProps={menuStyle ? menuStyle : MenuProps}
        sx={
          extraSx
            ? extraSx
            : {
                '& .Mui-selected': {
                  backgroundColor: '#eed8d9 !important',
                },
                '& .MuiInputBase-root': {
                  background: '#f3f3f3',
                  display: 'flex',
                  height: '46px !important',
                },
                textTransform: 'capitalize',
              }
        }
        className={className}
        onOpen={() => {
          setShowPlaceHolder(true);
          if (onOpen) onOpen();
        }}
        onFocus={onFocus}
        onClose={() => {
          setShowPlaceHolder(false);
          setOptionList(optionListAll);
        }}
        onChange={onChange && onChange}
        IconComponent={IconComponent ? IconComponent : undefined}
        style={extraStyle}
        value={value}
        displayEmpty
        disabled={disabled}
        id={id}
        name={name}
        ref={ref}
        error={!!error}>
        {searchable && (
          <ListSubheader style={{ backgroundColor: '#fff' }}>
            <TextField
              size="small"
              // Autofocus on textfield
              autoFocus
              type={type ? 'search' : ''}
              placeholder="Type to search..."
              fullWidth
              // InputProps={{
              //   startAdornment: (
              //     <InputAdornment position="start">
              //       <SearchIcon />
              //     </InputAdornment>
              //   ),
              // }}
              value={inputValue}
              onChange={(e) => {
                const trimmedText = String(e.target.value.trimStart());
                if (!String(/^\s/.test(trimmedText))) {
                  return;
                }
                setInputValue(trimmedText);
                debouncedResults(trimmedText);
              }}
              onKeyDown={(e) => {
                if (e.key !== 'Escape') {
                  // Prevents autoselecting item while typing (default Select behaviour)
                  e.stopPropagation();
                }
              }}
            />
          </ListSubheader>
        )}

        {!showPlaceHolder && !UploadResume && (
          <MenuItem value="">
            <span style={{ color: '#8f8a8a' }}>{placeHolder}</span>
          </MenuItem>
        )}
        {UploadResume && !showPlaceHolder && (
          <MenuItem value={undefined} disabled>
            <span
              style={{ color: '#8f8a8a' }}
              className="UploadPlaceholderStyle">
              {placeHolder}
            </span>
          </MenuItem>
        )}

        {optionList.length ? (
          optionList.map((item: any, index: number) => {
            return (
              <MenuItem
                key={index}
                sx={{
                  backgroundColor: valueHighLigt
                    ? valueHighLigt === item[valueKey]
                      ? '#eed8d9 !important'
                      : 'transparent'
                    : item[valueKey] === value
                    ? '#eed8d9 !important'
                    : 'transparent',
                  textTransform: 'capitalize',
                  ...(menuItemSx ? menuItemSx : {}),
                }}
                value={
                  valueKey === 'date'
                    ? moment(item[valueKey]).format('DD-MM-YYYY')
                    : item[valueKey]
                }
                selected={
                  selectedValue !== '' &&
                  String(item[valueKey]) === String(selectedValue)
                }>
                {labelKey === 'date'
                  ? moment(item[labelKey]).format('DD-MM-YYYY')
                  : item[labelKey]}
                {label1Key ? ` ${String(item[label1Key])}` : ''}
              </MenuItem>
            );
          })
        ) : (
          // <MenuItem value={''} disabled />
          <MenuItem
            value={'loading'}
            disabled
            sx={{ justifyContent: 'center' }}>
            {/* <span style={{ color: '#8f8a8a'}}> */}
            {loading ? (
              <CircularProgress size={20} sx={{ color: 'red' }} />
            ) : (
              'No Records Found'
            )}
            {/* </span> */}
          </MenuItem>
        )}
      </Select>
      {error && <FormHelperText className="errorMsg">{error}</FormHelperText>}
    </>
  );
};

export default CustomSelect;
